<template>
  <svg viewBox="5 5 40 40">
    <g style="display: inline">
      <g>
        <path
          d="m34.63,26.05l-4.9,1.27-4.08-2.39,4.08-2.39,4.9,1.27s.05.01.08.01c.14,0,.27-.09.31-.24.04-.17-.06-.34-.23-.39l-4.28
          -1.12,4.11-2.41c.15-.09.2-.28.11-.43-.09-.15-.28-.2-.43-.11l-4.11,2.41,1.12-4.28c.04-.17-.06-.34-.23-.39-.17-.04-.34.06
          -.39.23l-1.28,4.89-4.07,2.39v-4.72l3.58-3.58c.12-.12.12-.32,0-.45-.12-.12-.32-.12-.45,0l-3.13,3.13v-4.77c0-.17-.14-.32-.32
          -.32s-.32.14-.32.32v4.77l-3.13-3.13c-.12-.12-.32-.12-.45,0-.12.12-.12.32,0,.45l3.58,3.58v4.72l-4.07-2.39-1.28-4.89c-.04
          -.17-.22-.27-.39-.23-.17.04-.27.22-.23.39l1.12,4.28-4.11-2.41c-.15-.09-.34-.04-.43.11-.09.15-.04.34.11.43l4.11,2.41
          -4.28,1.12c-.17.04-.27.22-.23.39.04.14.17.24.31.24.03,0,.05,0,.08-.01l4.9-1.28,4.08,2.39-4.08,2.39-4.9-1.27c-.17-.04-.34.06
          -.39.23-.04.17.06.34.23.39l4.28,1.12-4.11,2.41c-.15.09-.2.28-.11.43.06.1.16.16.27.16.05,0,.11-.01.16-.04l4.11-2.41-1.12,4.28c
          -.04.17.06.34.23.39.03,0,.05.01.08.01.14,0,.27-.09.31-.24l1.28-4.89,4.07-2.39v4.72l-3.58,3.58c-.12.12-.12.32,0,.45.12.12.32.12.45,0l3.13
          -3.13v4.77c0,.17.14.32.32.32s.32-.14.32-.32v-4.77l3.13,3.13c.06.06.14.09.22.09s.16-.03.22-.09c.12-.12.12-.32,0-.45l-3.58-3.58v
          -4.72l4.07,2.39,1.28,4.89c.04.14.17.24.31.24.03,0,.05,0,.08-.01.17-.04.27-.22.23-.39l-1.12-4.28,4.11,2.41c.05.03.11.04.16.04.11,0,.21
          -.06.27-.16.09-.15.04-.34-.11-.43l-4.11-2.41,4.28-1.12c.17-.04.27-.22.23-.39-.04-.17-.22-.27-.39-.23Z"
        />
      </g>
    </g>
    <g style="display: inline">
      <g>
        <path
          d="M11.81,13.09l0.59,4.47l-0.74,0.1l-0.4-3c-1.98,2.84-3.03,6.15-3.03,9.64c0,5.67,2.82,10.94,7.55,14.09l-0.55,0.83
			c-5.01-3.34-8-8.92-8-14.92c0-3.67,1.1-7.15,3.16-10.14l-2.84,0.59L7.4,14L11.81,13.09 M12.66,11.89l-1.05,0.22L7.2,13.02
			l-0.98,0.2l0.2,0.98l0.15,0.74l0.2,0.98l0.98-0.2l0.6-0.12c-1.4,2.68-2.13,5.65-2.13,8.7c0,6.34,3.16,12.23,8.44,15.76l0.83,0.55
			l0.55-0.83l0.55-0.83l0.55-0.83l-0.83-0.55c-4.45-2.96-7.11-7.92-7.11-13.26c0-2.29,0.49-4.52,1.43-6.57l0.01,0.07l0.13,0.99
			l0.99-0.13l0.74-0.1l0.99-0.13l-0.13-0.99l-0.59-4.47L12.66,11.89L12.66,11.89z"
        />
      </g>
      <g>
        <path
          d="M43.06,24.29c0,4.79-1.86,9.29-5.25,12.67c-3.38,3.38-7.88,5.25-12.67,5.25c-1.82,0-3.61-0.29-5.33-0.82l1.41,2.53
			l-0.66,0.37l-2.19-3.93l4.08-1.9l0.32,0.68l-2.75,1.28c1.65,0.53,3.37,0.81,5.13,0.81c4.52,0,8.77-1.76,11.96-4.95
			c3.19-3.2,4.95-7.44,4.95-11.96H43.06 M44.06,23.29h-1h-1h-1v1c0,4.25-1.66,8.25-4.66,11.26c-3.01,3.01-7,4.66-11.26,4.66
			c-0.68,0-1.37-0.05-2.05-0.14l0.1-0.05l0.91-0.42l-0.42-0.91l-0.32-0.68l-0.42-0.91l-0.91,0.42l-4.08,1.9l-0.97,0.45l0.52,0.94
			l2.19,3.93l0.49,0.87l0.87-0.49l0.66-0.37l0.87-0.49l-0.49-0.87l-0.29-0.52c1.11,0.2,2.23,0.3,3.34,0.3
			c5.05,0,9.8-1.97,13.38-5.54c3.57-3.57,5.54-8.32,5.54-13.38V23.29L44.06,23.29z"
        />
      </g>
      <g>
        <path
          d="M25.15,6.37c4.79,0,9.29,1.86,12.67,5.25c2.03,2.03,3.53,4.51,4.4,7.22l1.27-2.59l0.67,0.33l-1.98,4.05l-3.89-2.26
			l0.38-0.65l2.63,1.53c-0.81-2.6-2.24-4.98-4.18-6.92c-3.2-3.19-7.44-4.95-11.96-4.95c-3.91,0-7.73,1.37-10.75,3.85l-0.64-0.77
			C16.96,7.82,21,6.37,25.15,6.37 M25.15,5.37c-4.38,0-8.65,1.53-12.02,4.31l-0.77,0.64l0.64,0.77l0.64,0.77l0.64,0.77l0.77-0.64
			c2.84-2.34,6.43-3.62,10.11-3.62c4.25,0,8.25,1.66,11.26,4.66c1.13,1.13,2.09,2.44,2.83,3.86l-0.07-0.04l-0.87-0.5l-0.5,0.87
			l-0.38,0.65l-0.5,0.86l0.86,0.5l3.89,2.26l0.93,0.54l0.47-0.97l1.98-4.05l0.44-0.9l-0.9-0.44l-0.67-0.33l-0.9-0.44l-0.44,0.9
			l-0.26,0.54c-0.93-2.02-2.22-3.87-3.79-5.44C34.95,7.34,30.2,5.37,25.15,5.37L25.15,5.37z"
        />
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconGroeneWarmte extends Vue {}
</script>
